<template>
	<div>
		<table class="table">
			<thead>
				<tr>
					<th colspan="3">
						{{ lang.get('payments.prices.form.amounts.columns.description') }}
					</th>
					<th v-if="variants.length"></th>
					<th v-for="currency in currencies" :key="`header-${currency.code}`">
						{{ currency.code }}
					</th>
					<th></th>
					<th></th>
				</tr>
			</thead>
			<draggable
				v-model="variants"
				tag="tbody"
				animation="150"
				handle=".dragger"
				draggable=".draggable-item"
				filter=".form-control, a, .input-group"
				:prevent-on-filter="false"
			>
				<price-variant
					v-for="(variant, index) in variants"
					:key="`price-variant-${index}`"
					:variant="variant"
					:variants="variants"
					:position="index"
					:grabbed-item="grabbedItem"
					:currencies="currencies"
					:chapters="chapters"
					:chapter-visible="chapterVisible"
					:categories="categories"
					:fields="fields"
					:field-values="fieldValues"
					@deleted="deleteVariant"
					@chapterSelected="updateVariant"
					@categorySelected="updateVariant"
					@fieldSelected="updateVariant"
					@fieldValueSelected="updateVariant"
					@updateAmount="updateVariant"
					@grabItem="(key) => (grabbedItem = key)"
					@reorderItems="(reorderedItems) => (variants = [...reorderedItems])"
				/>
			</draggable>
			<tbody>
				<tr>
					<td colspan="3" valign="center">
						{{ lang.get('payments.prices.form.amounts.default') }}
					</td>
					<td v-if="variants.length"></td>
					<td v-for="currency in currencies" :key="`default-amount-${currency.code}`">
						<price-amount
							:name="`defaultAmount[amounts][${currency.code}]`"
							:amount="((defaultAmount || {})['amounts'] || {})[currency.code] || ''"
							:currency="currency"
						/>
					</td>
					<td></td>
					<td></td>
				</tr>
			</tbody>
		</table>
		<button v-if="enableVariants" class="btn btn-secondary" @click.prevent="addVariant">
			{{ lang.get('payments.prices.form.amounts.add') }}
		</button>
	</div>
</template>

<script>
import Draggable from 'vuedraggable';
import PriceVariant from './PriceVariant';
import PriceAmount from './PriceAmount';
import DraggableItem from '@/lib/components/Shared/DraggableItem.vue';

export default {
	inject: ['lang'],
	components: {
		Draggable,
		PriceVariant,
		PriceAmount,
		DraggableItem,
	},
	props: {
		currencies: {
			type: Array,
			default: () => [],
		},
		amounts: {
			type: Array,
			default: () => [],
		},
		defaultAmount: {
			type: Object,
			default: () => ({}),
		},
		chapters: {
			type: Array,
			default: () => [],
		},
		chapterVisible: {
			type: Boolean,
			default: false,
		},
		categories: {
			type: Array,
			default: () => [],
		},
		enableVariants: {
			type: Boolean,
			default: false,
		},
		fields: {
			type: Array,
			default: () => [],
		},
		fieldValues: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			variants: null,
			grabbedItem: null,
		};
	},
	created() {
		this.variants = JSON.parse(JSON.stringify(this.amounts));
	},
	methods: {
		deleteVariant(variant) {
			this.variants = this.variants.filter((v) => v.id !== variant.id);
		},
		addVariant() {
			this.variants.push({
				id: 'new-' + Date.now(),
				amounts: {},
				categoryId: '',
				chapterId: '',
			});
		},
		updateVariant(id, property, value) {
			const index = this.variants.findIndex((v) => v.id === id);

			if (index >= 0) {
				this.$set(this.variants[index], property, value);
			}
		},
	},
};
</script>
